// ServicesTabbedSection.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCheck, FaBars,  FaLaptop } from "react-icons/fa";
import CyberSecurityImage from '../Images/cyber-security.png';
import ManagedItImage from '../Images/manage-it-services.png';
import SoftwareImage from '../Images/software-services.png';
import ProfessionalImage from '../Images/professional-it.png';

const serviceTabs = [
  {
    id: 1,
    title: "Professional Services",
    description: "Professional Services are expert-led, project-based IT services. They help build businesses plan, implement, or improve technology solutions.",
    features: [
      "IT Strategic Planning",
      "IT Augmentation",
      "Digital Transformation Services"
    ],
    image: ProfessionalImage
  },
  {
    id: 2,
    title: "Managed IT Services",
    description: "Managed IT Services are ongoing, outsourced IT support and management solutions. They help businesses maintain, monitor, and optimize their IT systems 24/7.",
    features: [
      "IT Helpdesk Support",
      "Firewall Management",
      "IT Asset/Patch Management"
    ],
    image: ManagedItImage
  },
  {
    id: 3,
    title: "CyberSecurity Services",
    description: "Cybersecurity Services protect IT systems, networks, and data from cyber threats. They help protect systems and data from cyber attacks.",
    features: [
      "Endpoint Detection and Response (EDR) Service",
      "Vulnerability Management",
      "End User Awareness Training"
    ],
    image: CyberSecurityImage
  },
  {
    id: 4,
    title: "Software Development Services",
    description: "Software Development Services are professional services that design, build, and deliver custom software applications tailored to meet specific business needs.",
    features: [
      "Custom Application Design",
      "Agile Development Process",
      "Software Testing & Quality Assurance"
    ],
    image: SoftwareImage
  }
];

export default function ServicesTabbedSection() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="container-xxl service py-5 text-dark">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mx-auto mb-5" style={{ maxWidth: "600px" }}>
          <p className="d-inline-block border rounded text-navyblue fw-semibold py-1 px-3">
           <FaLaptop className="me-2"/> Our Services
          </p>
          <h1 className="display-5">Strategies for Secure Growth and Operational Excellence</h1>
        </div>

        <div className="row gx-3 gy-4"> {/* Reduced space between columns */}
          {/* Tabs Column */}
          <div className="col-lg-4">
            <div className="nav flex-column">
              {serviceTabs.map((tab, index) => (
                <button
                  key={tab.id}
                  className={`nav-link text-start border p-4 py-3 mb-3 w-100 fw-semibold rounded-2 fs-5 ${
                    index === activeTab ? "active bg-navyblue text-white" : "bg-white text-dark"
                  }`}
                  onClick={() => setActiveTab(index)}
                  style={{ cursor: "pointer", height: "90px" }} // Larger tab height
                >
                  <FaBars className="me-2" />
                  {tab.title}
                </button>
              ))}
            </div>
          </div>

          {/* Content Column */}
          <div className="col-lg-8">
            <div className="row g-3 align-items-center">
              {/* Larger Image */}
              <div className="col-md-6 text-center">
                <img
                  src={serviceTabs[activeTab].image}
                  alt={serviceTabs[activeTab].title}
                  className="img-fluid rounded"
                  style={{ maxHeight: "340px", objectFit: "contain" }} // Larger image
                />
              </div>

              {/* Larger Text Content */}
              <div className="col-md-6  p-4 rounded-2">
                <p className="mb-4 fs-5 lh-lg">
                  {serviceTabs[activeTab].description}
                </p>
                <ul className="list-unstyled fs-5 mb-4">
                  {serviceTabs[activeTab].features.map((feature, i) => (
                    <li key={i} className="mb-2">
                      <FaCheck className="text-navy me-2" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/services" className="btn-custom  rounded-5 px-4 py-2  fs-6 m-2">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
